import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";

import client from "../client";
import {
  setJuniorSubjects,
  setSeniorSubjects,
} from "../../../redux/slices/school/slice";
import handleApiError from "../../hooks/handleApiError";

export default function useFetchSchoolCurriculum(category) {
  const { schoolId } = useParams();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const request = useCallback(
    async (_category = category) => {
      try {
        setLoading(true);
        const res = await client.get(
          `/curriculum/school/${schoolId}/${_category}`
        );

        if (_category === "junior") dispatch(setJuniorSubjects(res.data?.data));
        if (_category === "senior") dispatch(setSeniorSubjects(res.data?.data));

        setLoading(false);
        return true;
      } catch (error) {
        setLoading(false);
        handleApiError(error);
      }
    },
    [schoolId, dispatch, category]
  );

  useEffect(() => {
    if (category) request(category);
  }, [request, schoolId, category]);

  return { loading, request };
}
